import { render, staticRenderFns } from "./WhatsappAudienceTable.vue?vue&type=template&id=f2d2d84c&scoped=true&"
import script from "./WhatsappAudienceTable.vue?vue&type=script&lang=js&"
export * from "./WhatsappAudienceTable.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappAudienceTable.vue?vue&type=style&index=0&id=f2d2d84c&lang=scss&scoped=true&"
import style1 from "./WhatsappAudienceTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d2d84c",
  null
  
)

export default component.exports